module.exports = __webpack_public_path__ + "img/00501510_que_thu_thai_korea_hello_baby_dang_but_5843_62f4_large_7a7f4986f3.febb0583.webp";